/**
 * i18n de Costos y stock (v3) — área SHELL: navegación, marca y lo común (cs.shell.*).
 * "Lo común" incluye el vocabulario que comparten las 4 áreas (estados del plato y del insumo,
 * unidades, la columna de stock, guardar/reintentar): una sola fuente, así "Revisá" o
 * "Alcanza p/ 14" dicen lo mismo en la lista, en la ficha y en la compra. Se leen con los
 * helpers de src/features/costs/v3/shell/labels.js.
 */
const shell = {
  es: {
    "cs.shell.brand.stock": "Costos y stock",
    "cs.shell.brand.profit": "Costos y ganancias",
    "cs.shell.brand.neutral": "Costos",
    "cs.shell.back.panel": "Panel",
    "cs.shell.back.panelAria": "Volver al panel",
    "cs.shell.back.comandas": "Comandas",
    "cs.shell.back.comandasAria": "Volver a Comandas",
    "cs.shell.backAria": "Volver",
    "cs.shell.exit": "Salir",
    "cs.shell.close": "Cerrar",
    "cs.shell.tabsAria": "Secciones de Costos",
    "cs.shell.tab.platos": "Platos",
    "cs.shell.tab.insumos": "Insumos",
    "cs.shell.tab.ajustes": "Ajustes",
    "cs.shell.tab.cargar": "Cargar",
    "cs.shell.tab.cargarAria": "Cargar: compra, precios, insumo o plato",
    "cs.shell.loading": "Cargando tus costos…",
    "cs.shell.error.title": "No pudimos abrir tus costos",
    "cs.shell.error.body": "Revisá la conexión y probá de nuevo. Lo que ya cargaste sigue guardado.",
    "cs.shell.error.retry": "Reintentar",
    "cs.shell.currency": "Tus costos están en {costs} y la carta en {menu}: las cuentas mezclan monedas. Revisá los precios de tus insumos.",
    "cs.shell.mas.title": "¿Qué querés cargar?",
    "cs.shell.mas.compra": "Llegó mercadería",
    "cs.shell.mas.compraSub": "Cargá la factura y se actualizan los precios",
    "cs.shell.mas.compraSubStock": "Cargá la factura: precios y stock de una",
    "cs.shell.mas.precios": "Revisar precios",
    "cs.shell.mas.preciosSub": "Los insumos que más pesan en tus platos",
    "cs.shell.mas.insumo": "Agregar un insumo",
    "cs.shell.mas.insumoSub": "Algo que comprás y todavía no está en la lista",
    "cs.shell.mas.costear": "Costear un plato",
    "cs.shell.mas.costearSub": "Sigue con el próximo sin costear",
    "cs.shell.mas.contar": "Contar lo que hay",
    "cs.shell.mas.contarSub": "Una planilla para toda la heladera",
    "cs.shell.mas.perdida": "Anotar una pérdida",
    "cs.shell.mas.perdidaSub": "Se venció, se quemó, se cayó",
    "cs.shell.mas.allCosted": "Ya costeaste todos tus platos",
    // ── Vocabulario COMÚN de las 4 áreas (estados con nombre fijo, §6 de la propuesta): las
    //    pantallas los leen con los helpers de v3/shell/labels.js, nunca con su propia clave.
    "cs.shell.status.bien": "Bien",
    "cs.shell.status.justo": "Justo",
    "cs.shell.status.revisa": "Revisá",
    "cs.shell.status.perdes": "Perdés",
    "cs.shell.status.incompleto": "Incompleto",
    "cs.shell.status.sincostear": "Sin costear",
    "cs.shell.status.aproximado": "Aproximado",
    "cs.shell.ing.bien": "Bien",
    "cs.shell.ing.reponer": "Reponer",
    "cs.shell.ing.sinstock": "Sin stock",
    "cs.shell.ing.sincontar": "Sin contar",
    "cs.shell.ing.vencido": "Contá de nuevo",
    "cs.shell.ing.nocontrolado": "No controlado",
    "cs.shell.ing.sinprecio": "Falta precio",
    "cs.shell.unit.kg": "kg",
    "cs.shell.unit.g": "g",
    "cs.shell.unit.l": "l",
    "cs.shell.unit.ml": "ml",
    "cs.shell.unit.u": "unid.",
    "cs.shell.unit.doc": "doc.",
    "cs.shell.avail.ok": "Alcanza p/ {n}",
    "cs.shell.avail.low": "Quedan {n}",
    "cs.shell.avail.out": "Agotado",
    "cs.shell.avail.unc": "Falta contar",
    "cs.shell.avail.uncShort.sinVentas": "Sin ventas",
    "cs.shell.avail.uncShort.vencido": "Contá de nuevo",
    "cs.shell.avail.uncShort.unidadRota": "Unidad rota",
    "cs.shell.avail.no": "No descuenta",
    "cs.shell.avail.noWhy": "No descuenta: {why}",
    "cs.shell.nodesc.sincostear": "sin receta",
    "cs.shell.nodesc.aproximado": "costo aproximado",
    "cs.shell.nodesc.sinControlados": "ningún insumo controlado",
    "cs.shell.nodesc.unidadRota": "unidad rota en {name}",
    "cs.shell.pending.sinContar": "Falta contar {name}",
    "cs.shell.pending.vencido": "Contá de nuevo {name}",
    "cs.shell.pending.unidadRota": "Unidad rota en {name}",
    "cs.shell.pending.sinVentas": "No pudimos leer las ventas",
    "cs.shell.deletedIngredient": "(insumo borrado)",
    "cs.shell.save": "Guardar",
    "cs.shell.saving": "Guardando…",
    "cs.shell.cancel": "Cancelar",
    "cs.shell.unsaved": "Cambios sin guardar",
    "cs.shell.saveFailed": "No se guardó",
    "cs.shell.offline.off": "Sin conexión: lo que guardaste quedó en este equipo y se sube solo cuando vuelva internet. No lo cargues de nuevo.",
    "cs.shell.offline.slow": "Está tardando en guardarse. Si se cortó internet, se sube solo cuando vuelva: no lo cargues de nuevo.",
    "cs.shell.leave.title": "¿Salir sin guardar?",
    "cs.shell.leave.body": "Tenés cambios sin guardar en Costos. Si salís, se pierden.",
    "cs.shell.leave.go": "Salir igual",
    "cs.shell.leave.stay": "Seguir acá",
    "cs.shell.retry": "Reintentar",
  },
  en: {
    "cs.shell.brand.stock": "Costs & stock",
    "cs.shell.brand.profit": "Costs & profit",
    "cs.shell.brand.neutral": "Costs",
    "cs.shell.back.panel": "Panel",
    "cs.shell.back.panelAria": "Back to panel",
    "cs.shell.back.comandas": "Orders",
    "cs.shell.back.comandasAria": "Back to Orders",
    "cs.shell.backAria": "Back",
    "cs.shell.exit": "Exit",
    "cs.shell.close": "Close",
    "cs.shell.tabsAria": "Costs sections",
    "cs.shell.tab.platos": "Dishes",
    "cs.shell.tab.insumos": "Supplies",
    "cs.shell.tab.ajustes": "Settings",
    "cs.shell.tab.cargar": "Add",
    "cs.shell.tab.cargarAria": "Add: purchase, prices, supply or dish",
    "cs.shell.loading": "Loading your costs…",
    "cs.shell.error.title": "We couldn't open your costs",
    "cs.shell.error.body": "Check your connection and try again. What you already entered is still saved.",
    "cs.shell.error.retry": "Try again",
    "cs.shell.currency": "Your costs are in {costs} and the menu is in {menu}: the numbers mix currencies. Check your supply prices.",
    "cs.shell.mas.title": "What do you want to add?",
    "cs.shell.mas.compra": "A delivery arrived",
    "cs.shell.mas.compraSub": "Enter the invoice and prices update",
    "cs.shell.mas.compraSubStock": "Enter the invoice: prices and stock in one go",
    "cs.shell.mas.precios": "Review prices",
    "cs.shell.mas.preciosSub": "The supplies that weigh most on your dishes",
    "cs.shell.mas.insumo": "Add a supply",
    "cs.shell.mas.insumoSub": "Something you buy that isn't on the list yet",
    "cs.shell.mas.costear": "Cost a dish",
    "cs.shell.mas.costearSub": "Goes to the next dish without a cost",
    "cs.shell.mas.contar": "Count what you have",
    "cs.shell.mas.contarSub": "One sheet for the whole fridge",
    "cs.shell.mas.perdida": "Log a loss",
    "cs.shell.mas.perdidaSub": "It expired, burned or fell",
    "cs.shell.mas.allCosted": "All your dishes already have a cost",
    "cs.shell.status.bien": "Good",
    "cs.shell.status.justo": "Tight",
    "cs.shell.status.revisa": "Check it",
    "cs.shell.status.perdes": "Losing money",
    "cs.shell.status.incompleto": "Incomplete",
    "cs.shell.status.sincostear": "No cost yet",
    "cs.shell.status.aproximado": "Approximate",
    "cs.shell.ing.bien": "Good",
    "cs.shell.ing.reponer": "Restock",
    "cs.shell.ing.sinstock": "Out of stock",
    "cs.shell.ing.sincontar": "Not counted",
    "cs.shell.ing.vencido": "Count again",
    "cs.shell.ing.nocontrolado": "Not tracked",
    "cs.shell.ing.sinprecio": "No price",
    "cs.shell.unit.kg": "kg",
    "cs.shell.unit.g": "g",
    "cs.shell.unit.l": "l",
    "cs.shell.unit.ml": "ml",
    "cs.shell.unit.u": "pcs",
    "cs.shell.unit.doc": "doz.",
    "cs.shell.avail.ok": "Enough for {n}",
    "cs.shell.avail.low": "{n} left",
    "cs.shell.avail.out": "Sold out",
    "cs.shell.avail.unc": "Needs a count",
    "cs.shell.avail.uncShort.sinVentas": "No sales",
    "cs.shell.avail.uncShort.vencido": "Count again",
    "cs.shell.avail.uncShort.unidadRota": "Broken unit",
    "cs.shell.avail.no": "Doesn't deduct",
    "cs.shell.avail.noWhy": "Doesn't deduct: {why}",
    "cs.shell.nodesc.sincostear": "no recipe",
    "cs.shell.nodesc.aproximado": "approximate cost",
    "cs.shell.nodesc.sinControlados": "no tracked supplies",
    "cs.shell.nodesc.unidadRota": "unit mismatch in {name}",
    "cs.shell.pending.sinContar": "Count {name} first",
    "cs.shell.pending.vencido": "Count {name} again",
    "cs.shell.pending.unidadRota": "Unit mismatch in {name}",
    "cs.shell.pending.sinVentas": "We couldn't read the sales",
    "cs.shell.deletedIngredient": "(deleted supply)",
    "cs.shell.save": "Save",
    "cs.shell.saving": "Saving…",
    "cs.shell.cancel": "Cancel",
    "cs.shell.unsaved": "Unsaved changes",
    "cs.shell.saveFailed": "Not saved",
    "cs.shell.offline.off": "No connection: what you saved stays on this device and uploads by itself when the internet is back. Don't enter it again.",
    "cs.shell.offline.slow": "Saving is taking a while. If the internet dropped, it uploads by itself when it's back: don't enter it again.",
    "cs.shell.leave.title": "Leave without saving?",
    "cs.shell.leave.body": "You have unsaved changes in Costs. If you leave, they're lost.",
    "cs.shell.leave.go": "Leave anyway",
    "cs.shell.leave.stay": "Stay here",
    "cs.shell.retry": "Try again",
  },
  pt: {
    "cs.shell.brand.stock": "Custos e estoque",
    "cs.shell.brand.profit": "Custos e lucro",
    "cs.shell.brand.neutral": "Custos",
    "cs.shell.back.panel": "Painel",
    "cs.shell.back.panelAria": "Voltar ao painel",
    "cs.shell.back.comandas": "Comandas",
    "cs.shell.back.comandasAria": "Voltar às Comandas",
    "cs.shell.backAria": "Voltar",
    "cs.shell.exit": "Sair",
    "cs.shell.close": "Fechar",
    "cs.shell.tabsAria": "Seções de Custos",
    "cs.shell.tab.platos": "Pratos",
    "cs.shell.tab.insumos": "Insumos",
    "cs.shell.tab.ajustes": "Ajustes",
    "cs.shell.tab.cargar": "Lançar",
    "cs.shell.tab.cargarAria": "Lançar: compra, preços, insumo ou prato",
    "cs.shell.loading": "Carregando seus custos…",
    "cs.shell.error.title": "Não conseguimos abrir seus custos",
    "cs.shell.error.body": "Confira a conexão e tente de novo. O que você já lançou continua salvo.",
    "cs.shell.error.retry": "Tentar de novo",
    "cs.shell.currency": "Seus custos estão em {costs} e o cardápio em {menu}: as contas misturam moedas. Revise os preços dos seus insumos.",
    "cs.shell.mas.title": "O que você quer lançar?",
    "cs.shell.mas.compra": "Chegou mercadoria",
    "cs.shell.mas.compraSub": "Lance a nota e os preços se atualizam",
    "cs.shell.mas.compraSubStock": "Lance a nota: preços e estoque de uma vez",
    "cs.shell.mas.precios": "Revisar preços",
    "cs.shell.mas.preciosSub": "Os insumos que mais pesam nos seus pratos",
    "cs.shell.mas.insumo": "Adicionar um insumo",
    "cs.shell.mas.insumoSub": "Algo que você compra e ainda não está na lista",
    "cs.shell.mas.costear": "Custear um prato",
    "cs.shell.mas.costearSub": "Vai para o próximo sem custo",
    "cs.shell.mas.contar": "Contar o que tem",
    "cs.shell.mas.contarSub": "Uma planilha para a geladeira inteira",
    "cs.shell.mas.perdida": "Registrar uma perda",
    "cs.shell.mas.perdidaSub": "Venceu, queimou, caiu",
    "cs.shell.mas.allCosted": "Você já custeou todos os seus pratos",
    "cs.shell.status.bien": "Bem",
    "cs.shell.status.justo": "No limite",
    "cs.shell.status.revisa": "Revise",
    "cs.shell.status.perdes": "Prejuízo",
    "cs.shell.status.incompleto": "Incompleto",
    "cs.shell.status.sincostear": "Sem custo",
    "cs.shell.status.aproximado": "Aproximado",
    "cs.shell.ing.bien": "Bem",
    "cs.shell.ing.reponer": "Repor",
    "cs.shell.ing.sinstock": "Sem estoque",
    "cs.shell.ing.sincontar": "Sem contagem",
    "cs.shell.ing.vencido": "Conte de novo",
    "cs.shell.ing.nocontrolado": "Não controlado",
    "cs.shell.ing.sinprecio": "Falta preço",
    "cs.shell.unit.kg": "kg",
    "cs.shell.unit.g": "g",
    "cs.shell.unit.l": "l",
    "cs.shell.unit.ml": "ml",
    "cs.shell.unit.u": "un.",
    "cs.shell.unit.doc": "dz.",
    "cs.shell.avail.ok": "Dá para {n}",
    "cs.shell.avail.low": "Restam {n}",
    "cs.shell.avail.out": "Esgotado",
    "cs.shell.avail.unc": "Falta contar",
    "cs.shell.avail.uncShort.sinVentas": "Sem vendas",
    "cs.shell.avail.uncShort.vencido": "Conte de novo",
    "cs.shell.avail.uncShort.unidadRota": "Unidade quebrada",
    "cs.shell.avail.no": "Não desconta",
    "cs.shell.avail.noWhy": "Não desconta: {why}",
    "cs.shell.nodesc.sincostear": "sem receita",
    "cs.shell.nodesc.aproximado": "custo aproximado",
    "cs.shell.nodesc.sinControlados": "nenhum insumo controlado",
    "cs.shell.nodesc.unidadRota": "unidade errada em {name}",
    "cs.shell.pending.sinContar": "Falta contar {name}",
    "cs.shell.pending.vencido": "Conte {name} de novo",
    "cs.shell.pending.unidadRota": "Unidade errada em {name}",
    "cs.shell.pending.sinVentas": "Não conseguimos ler as vendas",
    "cs.shell.deletedIngredient": "(insumo apagado)",
    "cs.shell.save": "Salvar",
    "cs.shell.saving": "Salvando…",
    "cs.shell.cancel": "Cancelar",
    "cs.shell.unsaved": "Alterações não salvas",
    "cs.shell.saveFailed": "Não foi salvo",
    "cs.shell.offline.off": "Sem conexão: o que você salvou ficou neste aparelho e sobe sozinho quando a internet voltar. Não registre de novo.",
    "cs.shell.offline.slow": "Está demorando para salvar. Se a internet caiu, sobe sozinho quando voltar: não registre de novo.",
    "cs.shell.leave.title": "Sair sem salvar?",
    "cs.shell.leave.body": "Você tem alterações não salvas em Custos. Se sair, elas se perdem.",
    "cs.shell.leave.go": "Sair mesmo assim",
    "cs.shell.leave.stay": "Ficar aqui",
    "cs.shell.retry": "Tentar de novo",
  },
};

export default shell;
